import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Planzone } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  planzone: Identifiable<Planzone>;
  hasOrganization: boolean;
  retrieveCurrentPlanzone(
    credentials: Boundaries["retrieveCurrentPlanzone"]["request"],
  ): void;
}

function useRetrieveCurrentPlanzone(): ViewModel {
  const { selector, core } = useContext(CoreContext);
  const organization = useSelector(selector.getCurrentPlanzone).organization;

  return {
    isRequestPending: useSelector(
      selector.isRetrieveCurrentPlanzoneRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrieveCurrentPlanzoneRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrieveCurrentPlanzoneRequestFailure,
    ),
    hasOrganization: organization != null,
    planzone: useSelector(selector.getCurrentPlanzone),
    retrieveCurrentPlanzone: core.retrieveCurrentPlanzone,
  };
}

export { useRetrieveCurrentPlanzone };
